import React, { FC, useMemo } from "react";
import { ICalculationParametersData } from "types";
import { Table } from "components/Table/Table";
import { formatDate, formatPercent } from "utils/format";
import { MobileCalculationParameters } from "../MobileCalculationParameters/MobileCalculationParameters";

import styles from "../ContractPayouts/ContractPayouts.module.scss";
import { transformCalculationParametersData } from "utils/format";

export const CalculationParametersTable: FC<{
  data: ICalculationParametersData[];
}> = ({ data }) => {
  const transformedData = transformCalculationParametersData(data);

  const columns = [
    { title: "Начало периода", key: "beginningOfPeriod" },
    { title: "Конец периода", key: "endOfPeriod" },
    {
      title: "Тип расчета",
      key: "calculationType",
    },
    { title: "Основной %", key: "basicInterestRate" },
    {
      title: "Минимальный %",
      key: "minimumInterestRate",
    },
  ];

  const formattedData = useMemo(() => {
    return transformedData.length > 0
      ? transformedData.map(
          (item: ICalculationParametersData, index: number) => ({
            key: index,
            value: {
              beginningOfPeriod: formatDate(item.beginningOfPeriod),
              endOfPeriod: formatDate(item.endOfPeriod),
              calculationType: item.calculationType,
              basicInterestRate: formatPercent(item.basicInterestRate),
              minimumInterestRate: formatPercent(item.minimumInterestRate),
            },
          })
        )
      : [{ key: "empty", value: { beginningOfPeriod: "Нет данных" } }];
  }, [transformedData]);

  return (
    <div className={styles.wrapper}>
      <Table columns={columns} data={formattedData} className={styles.table} />
      <MobileCalculationParameters
        data={data}
        classname={styles.mobileDetails}
      />
    </div>
  );
};
